import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import Date from "@saleor/components/Date";
import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { PageheaderPageFormData } from "../PageheaderPage";

export interface PageheaderSummaryProps {
  data: PageheaderPageFormData;
}

const PageheaderSummary: React.FC<PageheaderSummaryProps> = ({ data }) => {
  const intl = useIntl();

  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.summary)} />
      <CardContent>
        <Typography variant="caption">
          <FormattedMessage defaultMessage="Name" description="pageheader name" />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.name, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage defaultMessage="PC Display" description="value display in pc" />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.pcContentFormatted, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage defaultMessage="Mobile Display" description="value display in mobile" />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.mobileContentFormatted, <Skeleton />)}
        </Typography>

        <CardSpacer />
        <Hr />
        <CardSpacer />

        <Typography variant="caption">
          <FormattedMessage {...commonMessages.startDate} />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(
            () =>
              data.startDate === null || data.startDate === "" ? "-" : <Date date={data.startDate} plain />,
            <Skeleton />
          )}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage {...commonMessages.endDate} />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(
            () =>
              data.endDate === null || data.endDate === "" ? "-" : <Date date={data.endDate} plain />,
            <Skeleton />
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};
PageheaderSummary.displayName = "PageheaderSummary";
export default PageheaderSummary;
